
(function () {

	var myObj = {};
	myObj.checkIfBDCLoaded = null;

	myObj.checkForBDC = function(){
        if(typeof window.BDC.Utils != "undefined"){
            this.init();
            clearInterval(this.checkIfBDCLoaded);
            this.checkIfBDCLoaded = null;
        }
    };

	myObj.breakpoints = {
		breakpoints:{
			isBP: function(bp){

				var breaks = {
					'pixel-ratio-zero': (function () {return window.matchMedia("only screen and (-webkit-min-device-pixel-ratio:0)").matches; }()),
					's-down': (function () {return window.matchMedia("only screen and (max-width: 575px)").matches; }()),
					's-up': (function () {return window.matchMedia("only screen and (min-width: 576px)").matches; }()),
					'm-down': (function () {return window.matchMedia("only screen and (max-width: 767px)").matches; }()),
					'm-up': (function () {return window.matchMedia("only screen and (min-width:768px)").matches; }()),
					'm-up-l-down': (function () {return window.matchMedia("only screen and (min-width: 768px) and (max-width: 991px))").matches; }()),
					'l-down': (function () {return window.matchMedia("only screen and (max-width: 991px)").matches; }()),
					'l-up': (function () {return window.matchMedia("only screen and (min-width:992px)").matches; }()),
					'l-up-xl-down': (function () {return window.matchMedia("only screen and (min-width: 992px) and (max-width: 1199px)").matches; }()),
					'xl-up': (function () {return window.matchMedia("only screen and (min-width:1200px)").matches; }()),
					'1024-down': (function () {return window.matchMedia("only screen and (max-width:1024px)").matches; }())
				};

				if(typeof bp == "undefined"){
					return false;
				}
				
				var breakpoint = breaks[bp];
				if(typeof breakpoint != 'undefined'){
					return breakpoint;
				}
		    	return false
		    }
		}
	};


    myObj.init = function() {

    	if( Object.assign != undefined){
			window.BDC.Utils = Object.assign(window.BDC.Utils, this.breakpoints);
		}
		else{
			 window.BDC.Utils = $.extend(window.BDC.Utils, this.breakpoints);	
		}
 		window.addEventListener("resize", this.getBreakPoints);

    };

    myObj.checkForBDC = myObj.checkForBDC.bind(myObj);
    myObj.init = myObj.init.bind(myObj);
    myObj.checkIfBDCLoaded = setInterval(myObj.checkForBDC,200);
}());

